export const MODAL_TYPE = {
    BANK_ID: 'BANK_ID',
    SWISH_HANDEL: 'SWISH_HANDEL'
};

export const MODAL_STATUS = {
    START: 'START',
    COMPLETE: 'COMPLETE',
    ERROR: 'ERROR'
};

export const PAYMENT_OPTIONS = {
    CARD: 'Card',
    APPLEPAY: 'ApplePay',
    GOOGLEPAY: 'GooglePay',
    SWISH_HANDEL: 'SwishHandel',
    VISA_MASTERCARD: 'VisaMasterCard'
};

export const PAYMENT_OPTION_STATUS = {
    AVAILABLE: 'Available',
    UNAVAILABLE_DUE_TO_AMOUNT: 'UnavailableDueToAmount'
};

export default () => ({
    invoice: {},
    ongoingPaymentAttempt: {
        invoicePaymentAttemptId: null,
        paymentMethod: null
    },
    payment: {
        hasError: false,
        isFetching: false,
        paymentOptions: null,
        selectedPayment: null,
        paymentMethodData: null,
        modal: {
            open: '',
            status: MODAL_STATUS.START
        }
    },
    checkoutSummary: {
        hasError: false,
        isFetching: false
    }
});
